/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: utils/passwordGenerators.ts
 🗓️ Created: 2025-01-15
 🧩 Description:
    Password generation utilities for Hot Desking module.
────────────────────────────────────────────────────────────────*/

/**
 * Generates a random alphanumeric password
 * Format: Random string of alphanumeric characters
 */
export function generateDefaultSecret(): string {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
}


